export default __webpack_public_path__ + "hashed/NokianTyresSans-Bold.6aa12033.woff2";